import React from 'react';
import TopBar from "../userNavbar/TopBar";
import MidBar from '../userNavbar/MidBar';
import BotBar from '../userNavbar/BotBar';

const UserNavbar = () => {
    return (
        <div className="sticky top-0 w-full z-50">
            <TopBar />
            <MidBar/>
            <BotBar/>
        </div>
    );
};

export default UserNavbar;